import { hideVisually } from 'polished'
import React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

type CheckBoxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  name?: string
  checkBoxSize?: number
  checked?: boolean
  label?: string
}

const CheckBox: React.FC<CheckBoxProps> = ({
  name,
  checkBoxSize = 24,
  checked,
  label,
  ...inputProps
}) => {
  return (
    <label
      css={{
        display: 'inline-grid',
        gridAutoColumns: 'auto',
        gridAutoFlow: 'column',
        gap: theme.space[2]
      }}
    >
      <input
        checked={checked}
        css={{
          ...hideVisually(),

          '&:checked + span': {
            backgroundColor: theme.colors.blue[0],
            borderColor: theme.colors.blue[0],
            transition: '150ms background-color, 150ms border-color',

            svg: {
              opacity: 1
            }
          }
        }}
        name={name}
        type="checkbox"
        {...inputProps}
      />
      <span
        css={{
          cursor: 'pointer',
          height: checkBoxSize,
          width: checkBoxSize,
          border: theme.border.base,
          borderRadius: theme.borderRadius[0],
          backgroundColor: theme.colors.grayOverlay[0],
          position: 'relative',
          opacity: inputProps.disabled && checked ? 0.5 : 1
        }}
      >
        <Icon
          css={{
            transition: '150ms opacity',
            opacity: 0,
            fontSize: theme.fontSizes[1],
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: theme.colors.white[0]
          }}
          icon="solidCheck"
        />
      </span>
      {label && (
        <span
          css={{
            fontSize: theme.fontSizes[2],
            fontWeight: theme.fontWeights[0]
          }}
        >
          {label}
        </span>
      )}
    </label>
  )
}

export default CheckBox
